import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import useTranslator from "../../hooks/useTranslator";
import TenantContext from "../../context/tenant/TenantContext";
import { toast } from "../../helper/common";
import "./deleteProfile.css";

const DeleteProfileModal = ({ open, onClose, currentLang }) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { softDeleteProfile } = useContext(TenantContext);
  const [deleteConfirmation, setDeleteConfirmation] = useState("");
  const [loading, setLoading] = useState(false);
  const deleteConfirmationWord = currentLang.startsWith("es")
    ? "BORRAR"
    : "DELETE";
  const canDeleteProfile =
    deleteConfirmation.trim().toUpperCase() === deleteConfirmationWord;

  if (!open) return null;

  const handleClose = () => {
    setDeleteConfirmation("");
    onClose();
  };

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await softDeleteProfile();
      onClose();
      navigate("/auth");
      toast.success(_t("profileDeletedSuccessfully", "Profile deleted"));
    } catch (err) {
      toast.error(_t("failedToDeleteProfile", "Failed to delete profile"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="delete-profile-modal-overlay"
      role="presentation"
      onClick={handleClose}
    >
      <section
        className="delete-profile-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-profile-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="delete-profile-modal__icon" aria-hidden="true">
          <img src="/images/delete-icon.svg" alt="" />
        </div>
        <h2 id="delete-profile-modal-title">
          {_t("deleteYourSkorProfile", "Delete profile confirmation title")}
        </h2>
        <p className="delete-profile-modal__intro">
          {_t(
            "beforeYouDecideRememberEverythingYourProfileOffers",
            "Delete profile confirmation introduction"
          )}
        </p>
        <ul className="delete-profile-modal__benefits">
          <li>
            {_t(
              "useItWithAnyLandlordOrAgencyToProveYourFinancialCapacity",
              "Delete profile benefit one"
            )}
          </li>
          <li>
            {_t(
              "weCanAssessYourProfileAndActAsYourGuarantor",
              "Delete profile benefit two"
            )}
          </li>
          <li>
            {_t(
              "automateYourRentPaymentsAndEarnRewardsForIt",
              "Delete profile benefit three"
            )}
          </li>
        </ul>
        <label className="delete-profile-modal__input-wrapper">
          <span>
            {_t("type", "Delete profile confirmation input label")}{" "}
            <strong>{deleteConfirmationWord}</strong>{" "}
            {_t("toConfirm", "Delete profile confirmation input label")}
          </span>
          <input
            type="text"
            value={deleteConfirmation}
            onChange={(event) => setDeleteConfirmation(event.target.value)}
            aria-label={_t(
              "deleteConfirmationWord",
              "Delete profile confirmation input"
            )}
            autoComplete="off"
          />
        </label>
        <div className="delete-profile-modal__actions">
          <button
            type="button"
            className="delete-profile-modal__keep-button"
            onClick={handleClose}
          >
            {_t("keepMyProfile", "Delete profile confirmation keep action")}
          </button>
          <button
            type="button"
            className="delete-profile-modal__confirm-button"
            disabled={!canDeleteProfile || loading}
            onClick={handleConfirm}
          >
            {_t(
              "deleteMyProfile",
              "Delete profile confirmation destructive action"
            )}
          </button>
        </div>
      </section>
    </div>
  );
};

export default DeleteProfileModal;
